"use client"

import * as React from "react"

import { PrimaryPageTemplate } from "@/components/templates/primary-page-template"
import { cn } from "@/lib/utils"

export type ExternalDemoIframeFrameProps = {
  src: string
  title: string
  className?: string
}

/**
 * Full-height third-party demo in the main pane. Host sidebar and page header
 * stay hidden via `demo-shell-routes`; the remote app may still show its own
 * chrome unless it honors an embed query param.
 */
export function ExternalDemoIframeFrame({
  src,
  title,
  className,
}: ExternalDemoIframeFrameProps) {
  return (
    <PrimaryPageTemplate
      maxWidthClassName="max-w-none"
      contentClassName="flex min-h-0 flex-1 flex-col p-0"
      bodyClassName="flex min-h-0 flex-1 flex-col"
      contentFillViewport={false}
    >
      <iframe
        title={title}
        src={src}
        loading="eager"
        className={cn(
          "block w-full flex-1 border-0 bg-background min-h-[calc(100svh-3.5rem)]",
          className,
        )}
      />
    </PrimaryPageTemplate>
  )
}
